import { useOffreService, useSociete } from '@europrocurement/l2d-domain';
import {
    TblRelPrescripteurArticleJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull as TblRelPrescripteurArticleJsonldCatalogueRead,
    TblRelPrescripteurArticleJsonld,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';

export type OffrePrescripteurRelArticle = TblRelPrescripteurArticleJsonldCatalogueRead &
    Record<string, unknown>;

const useOffreForm = () => {
    const { tblPrescripteurArticleApi } = useOffreService();
    const xIdSociete = useSociete();

    const createSurchargeArticle = (
        article: TblRelPrescripteurArticleJsonld,
    ): Promise<Array<OffrePrescripteurRelArticle>> =>
        new Promise((resolve, reject) => {
            const requestParameters: TblRelPrescripteurArticleJsonld = { ...article };

            if (xIdSociete === null) {
                throw new Error('missing societe');
            }

            const createPrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurPost({
                        xIdSociete,
                        tblRelPrescripteurArticleJsonld: requestParameters,
                    })
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<OffrePrescripteurRelArticle>),
                    )
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(createPrescripteurRelArticleTimeout);
        });

    const updateSurchargeArticle = (
        id: string,
        article: TblRelPrescripteurArticleJsonld,
    ): Promise<Array<OffrePrescripteurRelArticle>> =>
        new Promise((resolve, reject) => {
            const requestParameters: TblRelPrescripteurArticleJsonld = { ...article };

            if (xIdSociete === null) {
                throw new Error('missing societe');
            }

            const updatePrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurIdPut({
                        xIdSociete,
                        id,
                        tblRelPrescripteurArticleJsonld: requestParameters,
                    })
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<OffrePrescripteurRelArticle>),
                    )
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(updatePrescripteurRelArticleTimeout);
        });

    const deleteSurchargeArticle = (id: string): Promise<Array<OffrePrescripteurRelArticle>> =>
        new Promise((resolve, reject) => {
            if (xIdSociete === null) {
                throw new Error('missing societe');
            }

            const deletePrescripteurRelArticleTimeout = setTimeout(() => {
                tblPrescripteurArticleApi
                    .apiArticlePrescripteurIdDelete({
                        xIdSociete,
                        id,
                    })
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<OffrePrescripteurRelArticle>),
                    )
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
            console.warn(deletePrescripteurRelArticleTimeout);
        });
    return { createSurchargeArticle, updateSurchargeArticle, deleteSurchargeArticle };
};

export default useOffreForm;
